import { Body, Divider } from '@pinpointhq/thumbtack';
import * as React from 'react';
import { SanitizedRunningText } from './SanitizedRunningText';

export function RunningTextSection({
  divider = true,
  bold = false,
  text,
  title,
}: {
  divider?: boolean;
  bold?: boolean;
  text: string;
  title: string;
}) {
  if (!text) return null;

  return (
    <React.Fragment>
      {divider && <Divider muted={true} className="mar-v-2" />}
      <Body bold={bold} semiBold={true} className="mar-b-1">
        {title}
      </Body>
      <SanitizedRunningText text={text} muted={true} />
    </React.Fragment>
  );
}
